import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PhxOverviewComponent } from './phx-overview.component';
import { PhxOverviewPrefixComponent } from './phx-overview-prefix.component';
import { PhxOverviewItemComponent } from './phx-overview-item.component';

import { PhxIconModule } from '../icon/icon.module';
import { PhxTooltipModule } from '../tooltip/phx-tooltip.module';
import { PhxSkeletonModule } from '../skeleton/phx-skeleton.module';

@NgModule({
  declarations: [PhxOverviewComponent, PhxOverviewPrefixComponent, PhxOverviewItemComponent],
  imports: [CommonModule, PhxIconModule, PhxTooltipModule, PhxSkeletonModule],
  exports: [PhxOverviewComponent, PhxOverviewPrefixComponent, PhxOverviewItemComponent],
})
export class PhxOverviewModule {}
